import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { ClickAwayListener } from '@mui/material';
import React ,{ useState, useEffect } from 'react';
import styles from "./tableHeaderSelect.module.css";

export function TableHeaderSelect(props) {

    //const { id, index, placeholder, value, width, handleHeaderSelectChange, disabled, style } = props;
    const { id, index, placeholder, value, width, handleHeaderSelectChange, disabled , type, style } = props;

    const [popUp, setPopUp] = useState(false);
    const [filterValue, setFilterValue] = useState(placeholder);
    const [headerColor, setHeaderColor] = useState("lightgray");

    const handlePopUp = (boolean) => {
        setPopUp(boolean);
    }
    useEffect(()=>{
        setFilterValue(placeholder)
    },[placeholder])

    const handleChange = (event) => {
        if (event.target.value === "") {
            setFilterValue(placeholder);
            handlePopUp(false);
            handleHeaderSelectChange(id, event.target.value);
            setHeaderColor("lightgray");
        }
        else {
            setFilterValue(event.target.value)
            handlePopUp(false);
            handleHeaderSelectChange(id, event.target.value);
            setHeaderColor("black");
        }
    }

    return (
        <ClickAwayListener onClickAway={() => setPopUp(false)}>
            <th className={styles.th} style={{ minWidth: width, maxWidth: width, width: width, ...style }} key={index}>
                <div className={styles.outerContainer}>
                <div className={styles.container}>
                    {popUp
                        ? <div className={styles.popup}>
                            <button data-option-testid={placeholder} className={styles.header} value={""} onClick={handleChange}>{placeholder}</button>
                            {value.map((user, index) => {
                                return <button data-option-testid={user} className={styles.options} value={user} key={index} onClick={handleChange}>{user}</button>
                            })}
                        </div>
                        : <div className={styles.innerDiv} onClick={type === "role" ? undefined : () => handlePopUp(true)}>
                            <button data-option-testid={placeholder} className={styles.button} disabled={disabled} style={{ color: headerColor }}>
                                {filterValue}
                            </button>
                            <KeyboardArrowDownIcon></KeyboardArrowDownIcon>
                        </div>
                    }
                </div>
                </div>
            </th >
        </ClickAwayListener>
    );
}
